import React from 'react';

import './DateFilter.css';

const DateFilter = ({ fromDate, toDate, setFromDate, setToDate }) => (
  <div className="date-filter-container">
    <label>
      From:{' '}
      <input
        type="date"
        value={fromDate}
        onChange={e => setFromDate(e.target.value)}
      />
    </label>
    <label>
      To:{' '}
      <input
        type="date"
        value={toDate}
        onChange={e => setToDate(e.target.value)}
      />
    </label>
  </div>
);

export default DateFilter;
